import { render, staticRenderFns } from "./CreateDSR.vue?vue&type=template&id=a1049698&"
import script from "./CreateDSR.vue?vue&type=script&lang=js&"
export * from "./CreateDSR.vue?vue&type=script&lang=js&"
import style0 from "./CreateDSR.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports